<template>
  <div>
    <section-header heading="2" ja="meityromantic（メイティロマンティック）とは？"/>
    <div class="textArea">
      <p>
        「meityromantic（メイティロマンティック）」、略して「メイロマ」。<br>
        ２つの撮影ルームが選べるセガの新しいプリクラ機です。<br>
        詳細は公式サイトをご確認ください。
      </p>
      <p><span class="textLink" @click="onmeiromaWeb()">meityromantic 公式サイト</span></p>
    </div>

    <section-header heading="2" ja="モーメントとは？"/>
    <div class="textArea">
      <p>メイロマでは、「プリクラ(画像)」と同時に、「モーメント」と呼ばれる3秒間の動画を撮影することができます。</p>
      <p>
        モーメントは、プリクラのシャッターを切る前の3秒間を撮影します。<br>
        らくがき編集もでき、後で「プリクラON」にてデータをダウンロードできます。
      </p>
    </div>

    <section-header heading="2" ja="メイロマを遊べるお店は？"/>
    <div class="textArea">
      <p>
        遊べるお店は<span class="textLink" @click="onmeiromaLocation()">店舗検索</span>からご確認ください。
      </p>
    </div>
    <sub-btn @click="onAboutMeiroma()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutMeityromantic01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onAboutMeiroma() {
      this.$router.push("/AboutMeiyromantic")
    },
    onmeiromaWeb() {
      window.open("https://puri.sega.jp/meityromantic/", "_blank")
    },
    onmeiromaLocation() {
      window.open("https://puri.sega.jp/location-map/?id=108", "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.textLink { color: #DA2240; }
</style>
